import { BaseHubOptions } from "@gp/hub";

export const USER_HUB_SUBSCRIPTION_ID = "user-hub-notifications";

export class UserHubOptions extends BaseHubOptions {
	name: string = "notification-proxy";
	commonEventNames: string[] = ["ChannelUpdates"];
	messageSubscriptionIdResolver = () => USER_HUB_SUBSCRIPTION_ID;
}
